import React, { createContext, useContext, useState, useCallback } from 'react';
import { CITIES } from '../services/mockData.js';

const AppCtx = createContext(null);

export function AppProvider({ children }) {
  const [city, setCity]             = useState('Lucknow');
  const [bookings, setBookings]     = useState([]);
  const [notifications, setNotifs]  = useState([
    { id:'n1', title:'Booking Confirmed! ✅', body:'AC Service — 25 March at 10 AM',             time:'2 min ago',  read:false, type:'booking' },
    { id:'n2', title:'Special Offer 🎉',      body:'Pehli booking pe ₹100 cashback guaranteed!', time:'1 hour ago', read:false, type:'offer'   },
    { id:'n3', title:'New Service Added 🚜',  body:'Tractor Booking ab aapke city mein available',time:'1 day ago',  read:true,  type:'info'    },
  ]);

  const addBooking    = useCallback(b => setBookings(prev => [b, ...prev]), []);
  const markRead      = useCallback(id => setNotifs(prev => prev.map(n => n.id === id ? { ...n, read:true } : n)), []);
  const markAllRead   = useCallback(() => setNotifs(prev => prev.map(n => ({ ...n, read:true }))), []);
  const unreadCount   = notifications.filter(n => !n.read).length;

  return (
    <AppCtx.Provider value={{ city, setCity, cities: CITIES, bookings, addBooking, notifications, markRead, markAllRead, unreadCount }}>
      {children}
    </AppCtx.Provider>
  );
}

export const useApp = () => {
  const ctx = useContext(AppCtx);
  if (!ctx) throw new Error('useApp must be inside AppProvider');
  return ctx;
};
